module.exports = __webpack_public_path__ + "img/ic_search_user_1.782d3222.svg";